import React from 'react';
import styled from 'styled-components'
import { Container } from './Container'

const FooterWrapper = styled.footer`
    background-color: ${props => props.theme.color.lightgrey};
    padding: 3rem 0;
    text-align: center;
`

const Footer = () => {
    return (
        <FooterWrapper>
            <Container>
                <div>
                    <p>
                        <strong>ChuckNorrisJokes</strong> App by <a href="https://sergiopichardo.com">S.J.P.</a> was built using the <a href="https://api.chucknorris.io/">Chuck Norris API</a>.
                    </p>
                </div>
            </Container>
        </FooterWrapper>
    )
}

export default Footer